import React from 'react';
import { IMenuType0 } from '@store/models.menu';
import { Button } from '@dataartdev/uikit/Button';
import { cnHeaderMenu } from '../HeaderMenu';
import { setParams } from '../utils/setNavigationParams';

interface Props extends React.ComponentPropsWithoutRef<'li'> {
  item: IMenuType0;
  inverted?: boolean;
  mouseEnter: () => void;
  mouseLeave: () => void;
  onHeaderMenu: () => void;
}

export const MenuItemType0 = ({
  item,
  inverted,
  mouseEnter,
  mouseLeave,
  onHeaderMenu,
}: Props) => {
  const { node, nodes = [] } = item;
  const { title, nodeUrl, externalLink, targetBlank, label } = node;

  if (!node) return null;

  const buttonAttrs = setParams({
    title: title,
    nodeUrl: nodeUrl,
    externalLink: externalLink,
    targetBlank: targetBlank,
  });

  return (
    <li
      className={`HeaderMenu-Item ${nodes?.length &&
        'HeaderMenu-Item_subItems'}`}
      onMouseEnter={mouseEnter}
      onMouseLeave={mouseLeave}
    >
      <Button
        inverted={inverted}
        className={cnHeaderMenu('Link', {
          inverted: !!label?.isInverted,
        })}
        view="transparent"
        size="s"
        {...buttonAttrs}
        badge={
          label && {
            text: label.value,
            inverted: !!label.isInverted,
            color: label.labelColor,
          }
        }
      />
      {nodes?.length > 0 && (
        <div className={cnHeaderMenu('SubList')}>
          <div className={cnHeaderMenu('SubList-Inner')}>
            <div className={cnHeaderMenu('Container')}>
              <div className={cnHeaderMenu('Columns')}>
                <div className={cnHeaderMenu('Columns-Primary')}>
                  <div className={cnHeaderMenu('Column Wide')}>
                    {nodes.map(
                      ({
                        externalLink,
                        label,
                        nodeUrl,
                        targetBlank,
                        title,
                      }) => {
                        const buttonAttrs = setParams({
                          title,
                          nodeUrl,
                          externalLink,
                          targetBlank,
                        });
                        return (
                          <Button
                            key={title}
                            className={cnHeaderMenu('SubLink', {
                              inverted: !!label?.isInverted,
                            })}
                            view="transparent"
                            onClick={onHeaderMenu}
                            {...buttonAttrs}
                            badge={
                              label && {
                                text: label.value,
                                inverted: !!label.isInverted,
                                color: label.labelColor,
                              }
                            }
                          />
                        );
                      }
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </li>
  );
};
